import React from "react";
import { useDispatch } from "react-redux";
import { openPrescriptionModal } from "./../../../../../../redux/actions/modals";
import PrescriptionZoomComponent from "./../../../modals/PrescriptionZoomComponent";

const PrescriptionItem = (props) => {
  const { url, description, price } = props;
  const dispatch = useDispatch();
  return (
    <div className="prescription-item-holder">
      <div className="prescription-title">
                <div className="title">آزمایش با نسخه</div> <div className="count">برای {price.count} نفر</div>
            </div>
      <div className="top-holder">
        <div className="image-holder">
          <img src={url} width={100} height={100} alt="prescription-img" />
        </div>
        <div className="descriptions-holder">
          <div className="title">توضیحات نسخه</div>
          <div className="description">{description}</div>
        </div>
      </div>
      <div className="buttons-holder">
        <button className="btn btn-outline btn-primary btn-sm" 
          onClick={() => {
              dispatch(openPrescriptionModal(url))
          }}
        >مشاهده</button>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => {
            let popup = window.open();
            popup.document.write('<img src="' + url + "\" alt='' />");
            popup.focus(); //required for IE
            popup.print();
          }}
        >
          چاپ
        </button>
      </div>
      <PrescriptionZoomComponent />
    </div>
  );
};

export default PrescriptionItem;
